import client from "./client";

const RULES_BASE_PATH = "/api/v1/rules";

export async function listRules({
  active_only = true,
  product_type,
  channel_type,
  limit = 100,
  offset = 0,
} = {}) {
  const res = await client.get(RULES_BASE_PATH, {
    params: {
      active_only,
      product_type,
      channel_type,
      limit,
      offset,
    },
  });
  return res.data;
}

export async function getRule(ruleId) {
  const res = await client.get(`${RULES_BASE_PATH}/${ruleId}`);
  return res.data;
}

export async function createRule(ruleData) {
  const res = await client.post(RULES_BASE_PATH, ruleData);
  return res.data;
}

export async function updateRule(ruleId, ruleData) {
  const res = await client.patch(`${RULES_BASE_PATH}/${ruleId}`, ruleData);
  return res.data;
}

export async function deleteRule(ruleId) {
  await client.delete(`${RULES_BASE_PATH}/${ruleId}`);
}

export async function deactivateRule(ruleId) {
  await deleteRule(ruleId);
}

export async function listRuleVersions(ruleId) {
  const res = await client.get(`${RULES_BASE_PATH}/${ruleId}/versions`);
  return res.data;
}

export async function createRuleVersion(ruleId, versionData) {
  const res = await client.post(`${RULES_BASE_PATH}/${ruleId}/versions`, versionData);
  return res.data;
}

export async function updateRuleVersion(ruleId, versionNumber, versionData) {
  const res = await client.patch(`${RULES_BASE_PATH}/${ruleId}/versions/${versionNumber}`, versionData);
  return res.data;
}

export async function deleteRuleVersion(ruleId, versionNumber) {
  await client.delete(`${RULES_BASE_PATH}/${ruleId}/versions/${versionNumber}`);
}

export async function getRulePreference(ruleId) {
  const res = await client.get(`${RULES_BASE_PATH}/${ruleId}/preference`);
  return res.data;
}

export async function updateRulePreference(ruleId, preferenceData) {
  const res = await client.put(`${RULES_BASE_PATH}/${ruleId}/preference`, preferenceData);
  return res.data;
}

export async function importRules(fileId) {
  const res = await client.post(`${RULES_BASE_PATH}/import`, { file_id: fileId });
  return res.data;
}

export async function listPipelineConfigs() {
  const res = await client.get(`${RULES_BASE_PATH}/configs`);
  return res.data;
}

export async function createPipelineConfig(configData) {
  const res = await client.post(`${RULES_BASE_PATH}/configs`, configData);
  return res.data;
}

export async function getMyRulesSnapshot() {
  const res = await client.get(`${RULES_BASE_PATH}/snapshot`);
  return res.data;
}

export async function activatePipelineConfig(configId) {
  const res = await client.post(`${RULES_BASE_PATH}/configs/${configId}/activate`);
  return res.data;
}

// ---- No-code authoring -----------------------------------------------------

// Validate a draft spec and run it on a sample push (synchronous).
export async function previewRule(payload) {
  const res = await client.post(`${RULES_BASE_PATH}/preview`, payload);
  return res.data;
}

// Submit an owned private rule for moderation.
export async function publishRule(ruleId) {
  const res = await client.post(`${RULES_BASE_PATH}/${ruleId}/publish`);
  return res.data;
}

// Withdraw an owned rule back to private.
export async function unpublishRule(ruleId) {
  const res = await client.post(`${RULES_BASE_PATH}/${ruleId}/unpublish`);
  return res.data;
}

// Admin: list rules awaiting moderation.
export async function listPendingRules() {
  const res = await client.get(`${RULES_BASE_PATH}/pending`);
  return res.data;
}

// Admin: approve (-> public) or reject (-> private) a pending rule.
export async function moderateRule(ruleId, approve, reason) {
  const res = await client.post(`${RULES_BASE_PATH}/${ruleId}/moderate`, { approve, reason });
  return res.data;
}
